import { LinkedinService } from '@/services/Linkedin';
import { Route } from 'vue-router';

export enum LinkedinPostVisibility {
  PUBLIC = 'PUBLIC',
  CONNECTIONS = 'CONNECTIONS',
}

export enum PostMediaCategory {
  NONE = 'NONE',
  ARTICLE = 'ARTICLE',
  IMAGE = 'IMAGE',
}

export interface ShareOptions {
  linkedinOAuthCode: string;
  redirectUri?: string;
  content: string;
  visibility: string;
  postCategory: PostMediaCategory;
  imageSource: string;
}

interface ListenLinkedinPopupOptions {
  messageEvent: MessageEvent;
  linkedinPopup: Window;
  callback: (code: string) => unknown;
}

export const LINKEDIN_OAUTH_POPUP_IDENTIFIER = 'linkedin-redirection';

export const openLinkedinPopup = (): Window | null =>
  window.open(LinkedinService.generateOAuthURL(), '_blank', 'right=0,top=200,width=800,height=500');

export const listenLinkedinPopup = ({
  messageEvent,
  linkedinPopup,
  callback,
}: ListenLinkedinPopupOptions) => {
  const { from, code } = messageEvent.data;

  if (from !== LINKEDIN_OAUTH_POPUP_IDENTIFIER) return;

  linkedinPopup.close();
  callback(code);
};

export const isLinkedinOAuthCodeOnCurrentRoutePath = (route: Route): boolean => !!route.query.code;
